import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AlmanacPlusLogo',
  props: {
    msg: null
  },
  setup(__props: any) {

const props = __props as {
  msg: string;
};


const { msg } = toRefs(props);

return { __sfc: true,props, msg }
}

})